import { styled } from 'styled-components';

export const GridWrapper = styled.div`
  box-sizing: content-box;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-count), 1fr);
  column-gap: var(--grid-gutter);
  row-gap: var(--row-gap, 0);
  max-width: var(--grid-max-width);
  margin: 0 auto;
  padding-left: var(--grid-margin);
  padding-right: var(--grid-margin);

  transition: var(--transition--short);
  transition-property: padding;
  will-change: padding;

  > * {
    grid-column: 1 / -1;
  }
`;

export const GridColumnWrapper = styled.div`
  --column: 1 / -1;

  grid-column: var(--column) !important;
`;
